import morphdom from 'morphdom';

export class VROC {
	constructor() {
		this.components = new Map();
	}

	/**
	 * Динамическая загрузка компонента
	 * Получает HTML с сервера и вставляет в контейнер
	 */
	async loadComponent(component) {
		const { id, node, attach } = component;

		const container = typeof node === 'string'
			? document.querySelector(node)
			: node;

		if (!container) {
			throw new Error(`[VROC] Container not found: ${node}`);
		}

		component.container = container;
		this.components.set(id, component);

		if (!attach) {
			let html;
			if (component.htmlText) {
				// HTML уже загружен (оптимизация: POST с action)
				html = component.htmlText;
			} else if (component.xmlUrl) {
				// Загружаем HTML с сервера
				const response = await fetch(component.xmlUrl);
				html = await response.text();
			}
			if (html) {
				this._morph(component, html);
			}
		}

		return id;
	}

	/**
	 * Привязка к существующему DOM-элементу (уже отрендеренному сервером)
	 */
	attachComponent(component) {
		const { id, node } = component;

		const container = typeof node === 'string'
			? document.querySelector(node)
			: node;

		component.container = container;
		this.components.set(id, component);

		return id;
	}

	/**
	 * Обновление компонента новым HTML
	 */
	async updateComponent(id, newHtml) {
		const component = this.components.get(id);
		if (!component) {
			console.warn('[VROC] Component not found:', id);
			return;
		}
		if (!component.container) {
			console.warn('[VROC] Container is null for:', id);
			return;
		}

		this._morph(component, newHtml);

		if (typeof component.onUpdate === 'function') {
			component.onUpdate();
		}
	}

	/**
	 * Применяет morphdom для обновления DOM с минимальными изменениями
	 */
	_morph(component, newHtml) {
		const { container } = component;

		// Парсим новый HTML
		const temp = document.createElement('div');
		temp.innerHTML = newHtml.trim();

		// Если ответ сервера содержит обёртку, совпадающую с контейнером,
		// используем её как источник (чтобы избежать вложения контейнера в себя)
		let morphSource = temp;
		const firstChild = temp.firstElementChild;
		if (temp.children.length === 1 && firstChild && container.classList.length > 0) {
			const hasMatchingClass = Array.from(container.classList).some(
				cls => firstChild.classList.contains(cls)
			);
			if (hasMatchingClass && firstChild.tagName === container.tagName) {
				morphSource = firstChild;
			}
		}

		// morphdom обновляет содержимое контейнера
		morphdom(container, morphSource, {
			childrenOnly: true,

			onBeforeElUpdated(fromEl, toEl) {
				// Пропускаем JS-управляемые элементы (календари и т.д.)
				if (fromEl.hasAttribute && fromEl.hasAttribute('data-morph-skip')) {
					return false;
				}


				// Сохраняем активное состояние попапов (но не любых .active элементов)
				if (fromEl.classList && fromEl.classList.contains('active') && fromEl.classList.contains('popup')) {
					toEl.classList.add('active');
				}

				// Не трогаем элемент с фокусом — но только если он действительно
				// в том же контейнере. Иначе клик по ссылке-открытию попапа
				// блокирует обновление этого элемента, хотя сам он не должен
				// сохраняться (нет input/textarea).
				if (fromEl === document.activeElement) {
					const tag = fromEl.tagName;
					if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
						return false;
					}
				}

				return true;
			}
		});
	}

	/**
	 * Отключение компонента
	 */
	detachComponent(id) {
		const component = this.components.get(id);
		if (!component) return;

		if (component.container) {
			component.container.innerHTML = '';
		}

		this.components.delete(id);
	}
}
